// @ts-strict-ignore
import {
  Directive,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { LMFieldBaseComponent } from '@field/lm-field-base.component';
import { LMModel } from '@form/model';
import { LMFieldServiceAdapter } from '@field/lm-field-service-adapter';
import * as urltemplate from 'url-template';
import { LMFormRequestService } from '@form/services';
import { BehaviorSubject } from 'rxjs';

@Directive()
export class LMRadiobuttonBaseComponent extends LMFieldBaseComponent implements OnInit, OnDestroy {
  @Input() layoutObject: LMRadioButtonLayout;
  @Input() specFields: LMSpecFields;
  @Input() model: LMModel;

  public isHorizontal = false;
  private isUserDefined = false;
  public values: Array<LMStateValue> = [];

  public values$ = new BehaviorSubject<LMStateValue[]>([]);

  @HostBinding('class.field') hostClass = !this.isHorizontal;

  @HostBinding('attr.data-automation-id') dataFieldAutomationId = '';

  constructor(protected lmFormRequestService: LMFormRequestService,
              protected lmFieldServiceAdapter: LMFieldServiceAdapter) {
    super(lmFieldServiceAdapter);
  }

  // the sohoxi controls will run the validation on a click and will
  // remove the alert that was placed there; listening here will re-apply the alert
  @HostListener('click', [ '$event' ])
  onClick(event) {
    this.onChangeProcessAlerts();
    super.onClick(event);
  }

  // events
  ngOnInit() {
    super.ngOnInit();
    this.initialize(this.layoutObject, this.specFields, this.model);

    this.isUserDefined = this.specField.hasUserDefinedStates;
    // field class interferes with horizontal radio buttons
    // causes last radio to display when first radiobutton (not label) is checked
    this.isHorizontal = this._isHorizontal();;

    if (this.isUserDefined) {
      this.getUserDefinedStates();

    } else if (this.specField.stateValues) {
      if (this.layoutObject.limitedStates?.length > 0) {
        this.values = this.layoutObject.limitedStates;
        this.addValueToLimitedStates();
      } else {
        this.values = this.specField.stateValues;
      }
      this.values$.next(this.values);
    }

    this.fieldClassArray.push('radio-group');
    this.fieldClassArray.push('field-radio');
    this.setFieldClasses();

    if (!(this.displayAsText || this.displayAsTag)) {
      this.subscribeToInlineError();
    }

    this.dataFieldAutomationId = `lm-${this.fieldAutomationId}-field`;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  contextMenuClicked = ($event) => {
    this.onContextMenuEvent($event);
  };

  trackByValue(index: number, state: LMStateValue) {
    return state.value;
  }

  public onNgModelChange(value) {
    this.modelField.toDataValue(value, this.transformOptions);
  }

  public getUserDefinedStates(): void {
    this.busyIndicator = true;

    const compiledFormRequestUrl = urltemplate.parse(this.model.formUrlInfo.formRequestUrl);
    const formRequestUrl = compiledFormRequestUrl.expand({ resourceId: this.model.formResourceId });

    const dataView = this.model.getData();
    const actionName = this.model.action;

    this.lmFormRequestService
      .getUserDefinedStates(formRequestUrl, this.bindId, dataView, actionName)
      .subscribe( {
        next: (result: LMUserDefinedResponse) => {
          if (this.lmFieldServiceAdapter.lmContextService.userDefinedStatesPageSizeAndIndicator()) {
            if (result && result.hasOwnProperty('states') && Array.isArray(result.states)) {
              this.values = this.modelField.states = this.lmFieldServiceAdapter.lmFormatUtilService.fieldStatesToOptionsArray(result.states, false);
              this.values$.next(this.values);
              return;
            }
          } else {
            if (Array.isArray(result)) {
              this.values = this.modelField.states = this.lmFieldServiceAdapter.lmFormatUtilService.fieldStatesToOptionsArray(result, false);
              this.values$.next(this.values);
              return;
            }
          }

          // an error
          this.busyIndicator = false;
          this.lmFieldServiceAdapter.lmLoggerService.error([ 'Error in getUserDefinedStates', this.bindId, result ]);
      },
      error: (error) => {
        this.busyIndicator = false;
        this.lmFieldServiceAdapter.lmLoggerService.error(['Error in getUserDefinedStates', this.bindId, error]);
      }
    });
  }

  private _isHorizontal(): boolean {
    if (this.lmFieldServiceAdapter.lmContextService.isSmartPhone()) {
      return false;
    }

    return this?.field?.horizontalRadioButtons;
  }

  private addValueToLimitedStates(): void {
    if (!this.lmFieldServiceAdapter.lmFieldUtilService.isBlank(this.specField.type, this.modelField.value)) {
      // value set on the field, make sure it is in the limited states array
      if (!this.values.some((state: LMStateValue) => state.value === this.modelField.value) ) {
        const state: LMStateValue = this.modelField.states.filter((state: LMStateValue) => state.value === this.modelField.value)[0];
        this.values.unshift(state);
      }
    }
  }

}
